import '../game.css';

const React = require('react');
const { BarIndicator } = require('react-indicators');
const { CSSTransition } = require('react-transition-group');
const object = require('../../../define/object').default;
const assets = require('../../../assets').default;
const style = require('../game.style').default;
const { sound, soundType } = require('../../../core/sound').default;
// ===============================

const getObjectImage = (type) => {
    let imageSrc = undefined;
    switch (type) {
        case object.OBJ_BOM_RED:
            imageSrc = assets.ObjectPorinRed;
            break;
        case object.OBJ_BOM_GREEN:
            imageSrc = assets.ObjectPorinGreen;
            break;
        case object.OBJ_BOM_BLUE:
            imageSrc = assets.ObjectPorinBlue;
            break;
        case object.OBJ_BOM_YELLOW:
            imageSrc = assets.ObjectPorinYellow;
            break;
        case object.OBJ_MOB_ELVIRA:
            imageSrc = assets.ObjectMobElvira;
            break;
        case object.OBJ_MOB_LOLA:
            imageSrc = assets.ObjectMobLola;
            break;
        case object.OBJ_MOB_RUDO:
            imageSrc = assets.ObjectMobRudo;
            break;
        case object.OBJ_MOB_SEOHYUN:
            imageSrc = assets.ObjectMobSeohyun;
            break;
        case object.OBJ_MOB_ZILANT:
            imageSrc = assets.ObjectMobZilant;
            break;
        case object.OBJ_MOB_GARM:
            imageSrc = assets.ObjectMobGarm;
            break;
        case object.OBJ_MOB_NIGHTMARE:
            imageSrc = assets.ObjectMobNightMare;
            break;
        case object.OBJ_MOB_GRYPHON:
            imageSrc = assets.ObjectMobGryphon;
            break;
        case object.OBJ_TREASURE:
            imageSrc = assets.ObjectTreasure;
            break;
        case object.OBJ_IMMORTAL_CLYSTAL:
            imageSrc = assets.ObjectImmortalClystal;
            break;
        case object.OBJ_IMMORTAL_POLE:
            imageSrc = assets.ObjectImmortalPole;
            break;
        case object.OBJ_IMMORTAL_BED:
            imageSrc = assets.ObjectImmortalBed;
            break;
        case object.OBJ_IMMORTAL_TABLE:
            imageSrc = assets.ObjectImmortalTable;
            break;
        case object.OBJ_IMMORTAL_GATE:
            imageSrc = assets.ObjectImmortalGate;
            break;
        case object.OBJ_IMMORTAL_TOMB:
            imageSrc = assets.ObjectImmortalTomb;
            break;
        default:
            break;
    }
    return imageSrc;
}

const getWeaknessImage = type => {
    let imageSrc = undefined;
    switch (type) {
        case object.OBJ_BOM_RED:
            imageSrc = assets.WeaknessRed;
            break;
        case object.OBJ_BOM_GREEN:
            imageSrc = assets.WeaknessGreen;
            break;
        case object.OBJ_BOM_BLUE:
            imageSrc = assets.WeaknessBlue;
            break;
        case object.OBJ_BOM_YELLOW:
            imageSrc = assets.WeaknessYellow;
            break;
        default:
            break;
    }
    return imageSrc;
}

export default class objectComponent extends React.Component {
    componentDidMount() {
        this.damageShow = false;
        this.hitShow = false;
        this.damage = 0;
    }

    componentDidUpdate(prevProps) {
        const { soundEnable, isGamePlaying } = this.props;
        if (prevProps.hp > this.props.hp) {
            if (object.isPorinObject(this.props.type)) {
                sound.playSound(soundType.SE_DAMAGE_PORIN, soundEnable);
            }
            if (object.isTreasure(this.props.type)) {
                sound.playSound(soundType.SE_DAMAGE_TREASURE, soundEnable);
            }
            if (object.isMonsterObject(this.props.type)) {
                sound.playSound(soundType.SE_DAMAGE_MOB, soundEnable);
                this.damageShow = true;
                this.damage = prevProps.hp - this.props.hp;
            }
            if (isGamePlaying) {
                this.hitShow = true;
            }
        }
    }

    renderHp(hp, mhp, type) {
        if (object.isMonsterObject(type)) {
            if (hp >= 1 && mhp >= 1) {
                const ratio = hp / mhp;
                return (
                    <div style={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        zIndex: 11,
                    }}
                    >
                        <BarIndicator progress={ratio} width={style.panelSize - 2} color={'#5F5'} backgroundColor={'black'} />
                    </div>
                )
            }
        }
        return;
    }

    renderDamage() {
        return (
            <CSSTransition
                in={this.damageShow}
                timeout={300}
                unmountOnExit
                classNames="pop-damage"
                onEntered={() => this.damageShow = false}
            >
                <div className="pop-damage">
                    {this.damage}
                </div>
            </CSSTransition>
        )
    }

    renderHitEffect() {
        return (
            <CSSTransition
                in={this.hitShow}
                timeout={100}
                unmountOnExit
                classNames="pop-hit"
                onEntered={() => this.hitShow = false}
            >
                <div className="pop-hit" />
            </CSSTransition>
        )
    }


    renderWeakness(weakness) {
        if (weakness) {
            return (
                <img src={getWeaknessImage(weakness)}
                    style={{
                        position: 'absolute',
                        height: '200%',
                        width: '200%',
                        bottom: 0,
                        top: '-75%',
                        left: '-50%',
                        zIndex: 12
                    }} />
            )
        }
        return;
    }

    renderObject(type) {
        const object = getObjectImage(type);
        if (object) {
            return (
                <img src={object} style={{
                    position: 'absolute',
                    height: '150%',
                    width: '150%',
                    bottom: 0,
                    top: '-50%',
                    left: '-25%',
                    zIndex: 10
                }} />
            )
        }
        return;
    }

    render() {
        const { type, hp, mhp, weakness } = this.props;

        return (
            <div>
                {object &&
                    <>
                        {this.renderDamage()}
                        {this.renderHitEffect()}
                        {this.renderHp(hp, mhp, type)}
                        {this.renderWeakness(weakness)}
                        {this.renderObject(type)}
                    </>
                }
            </div>
        )
    }
}